import * as React from 'react'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
import { Alert, Card } from 'react-bootstrap'
import ApiCall from '../../components/ApiCall/ApiCall'
import Button from 'react-bootstrap/Button'
//import { LaptopWindows } from '@material-ui/icons'
require('./label.css')
/*
    this class is the page "aide" 
    the user will define labels to a sentence from a general conditions of use
*/
interface LabelState {
	error:boolean
	message:string
    text: string
    types: Array<LabelType>
    typeSelected: any
    uuIdLabel: string
    website_name: string
}

interface LabelType {
    type: string
    id: any
}

interface LabelProps {
}


export default class Label extends React.Component<LabelProps, LabelState> {
	private api = new ApiCall()

	constructor(props: LabelProps){
		super(props)
		this.state = {
			error : false,
			message:"",
            text: "",
            types:[],
            typeSelected:Number(-1),
            uuIdLabel:"",
            website_name:""
        };
        this.SubmitLabel = this.SubmitLabel.bind(this);
        this.handleChangeTypes = this.handleChangeTypes.bind(this);
	}

    writeError() {
        let {error, message} = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="danger" style={{"textAlign":"center"}}>
                        {message}
                    </Alert>
                </>
            );
        } else if (message !== "") {
            return (
                <>
                    <Alert variant="success">
                        {message}
                    </Alert>
                </>
            );
        }
	}

	componentDidMount = async () => {
        this.GetLabel();
	}
    
    GetLabel = async () => {
        const request = await this.api.ApiCall("labels", "GET", {}, localStorage.getItem('AccessToken'))
		if(request.status === 200)
		{
			this.setState({
				text : request.data.text,
                types : request.data.types,
                uuIdLabel : request.data.uuid,
                website_name: request.data.website_name
			})
		}
		else {
			this.setState({
                error: true,
                message: "Nous n'avons pas de CGU non-notées pour le moment. Merci de l'aide que vous souhaitez nous apporter, n'hésitez pas à revenir dans cette section pour voir si de nouvelles CGU sont à noter."
            })
		}
    }

    handleChangeTypes(e:any) {
        this.setState({ typeSelected: Number(e.target.value) });
    }

	render() {
		return (
			<>	
                <Header/>
				<div className={"boddy-settings"}>
					<div  className={"title-settings"}>
						<h1>Nous aider à labeliser des CGU ?</h1>
					</div>
					<div>
						{ this.writeError() }
                        <Card>
                            <Card.Body>
                                <div className={"card-container"}>
                                    <h2 className={"card-title"}>Veuillez <b>lire</b> et <b>labeliser</b> l'extrait de CGU ci-dessous :</h2>
                                    <br/>
                                    <br/>
                                    <br/>
                                    <h4 className={"card-title"}><b>{this.state.text}</b></h4>
                                    <br/>
                                    <br/>
                                    <select className={"card-select"} value={this.state.typeSelected} aria-label={"Default select example"} onChange={this.handleChangeTypes}>
                                        <option defaultValue="true" value={Number(-1)}>Choisissez le type de label</option>
                                        {this.state.types.map((item)=>
                                            <option value={item.id}>{item.type}</option>
                                        )}
                                    </select>
                                    <br/>
                                    <br/>
                                    <br/>
                                    {this.state.typeSelected === Number(-1) ? <Button id="card-button" variant="outline-success" disabled>Envoyer votre notation de label</Button> : <Button id="card-button" variant="outline-success" onClick={this.SubmitLabel}>Envoyer votre notation de label</Button> }
                                </div>
                            </Card.Body>
                        </Card>
                        <br/>
					</div>
				</div>
				<Footer/>
			</>
		);
	}

    SubmitLabel = async () => {
        if(this.state.typeSelected !== Number(-1)){
            const request = await this.api.ApiCall("labels", "POST", {
                uuidLabel: this.state.uuIdLabel,
                type: Number(this.state.typeSelected)
            }, localStorage.getItem('AccessToken'))
            this.GetLabel();
            if(request.status === 201){
                this.setState({
                    error: false,
                    message: "Votre notation est bien passée, merci de votre participation !",
                    typeSelected: Number(-1)
                })
            }
        } else {
            this.setState({
                error: true,
                message: "Veuillez choisir un label avant d'envoyer votre réponse. Merci d'avance pour votre participation !"
            })
        }
    }
}